/*
* Created on Mar 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useState} from 'react';
import ic_arrow_down from '../../../static/img/utils/ic-arrow-drop-down.svg'
import ic_remove from '../../../static/img/utils/ic-remove.svg'
import ic_contact_svg from '../../../static/img/utils/ic-contacts.svg';
import TextInputComponent from "../../common/Form/TextInputComponent";
import useToggle from "../../../hook/ToggleHook";
import ContactListInputComponent from "../../common/Form/ContactListInputComponent";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../../hook/OrganizationAPIHook";
import {EMAIL_FORMAT, get_primary_email} from "../../../service/common";
import Cookies from "js-cookie";
import ic_info_inline_svg from "../../../static/img/utils/ic-info-inline.svg";
import SelectInputComponent from "../../common/Form/SelectInputComponent";
import {InviteContactComponent, ROLE_LIST, ROLE_NOTES} from "../../account-list/AccountListInviteModalComponent";


const OrganizationInviteAdminComponent = ({newOrgId, wizard_data, disPatcher}) => {
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const [showInvite, setShowInvite] = useState(false);
    const [open, node] = useToggle();
    const access_token = sessionStorage.getItem('access_token');
    const currentOrg = JSON.parse(window.localStorage.getItem('currentOrg'));
    const [groups, setGroups] = useState([]);
    const [canAddMoreInvite, setCanAddMoreInvite] = useState(false);

    const validation = (event) => {
        const input_email = event.target.value
        const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
        const email = currentUser?.emails?.[0]?.email;
        const valid = input_email.match(new RegExp(EMAIL_FORMAT));
        if (!valid) {
            return t('@Email format incorrent.@');
        }
        if (input_email === email) {
            return t('@User already exists in the Organization.@');
        }

        if (wizard_data?.inviteList?.find(u => u.email === input_email || u.qid === input_email) ) {
            return t('@User already exists in the Organization.@');
        }
        return '';
    };

    const init_input = {
        qid: {value: '', error: null, required: true},
        role: {value: "", error: null, required: true},
        groups: {value: [], error: null, required: true},
        description: {value: '', error: null, required: false}
    }
    const [input, setInput] = useState(init_input);
    const [inviteList, setInviteList] = useState([
        {value: "", error: null, required: true, showAddMore: true, hideRemove: false, key: new Date().getTime()}
    ]);
    const [permission, setPermission] = useState("");

    const inviteAdmin = async () => {
        // let input_data = {
        //     organization_id: newOrgId,
        //     users: [
        //         {
        //             qid: input.qid.value,
        //             groups: input.groups.value.map((g)=>g.organization_group_id),
        //             description: input.description.value
        //         }
        //     ]
        // };
        // await OrganizationAPI.post(`organization_invitation`, null, input_data);
        disPatcher({type: 'inviteAdmin_uncheck_groups'});
        setShowInvite(true);
    }

    const toggleGroup = (g) => {
        disPatcher({type: 'inviteAdmin_toggleGroup', payload: {id: g.organization_group_id, checked: !g.checked}});
        setInput((prevInput)=>{
            return {
                ...prevInput,
                groups: {
                    ...prevInput.groups,
                    value: wizard_data.groups.filter((g)=>g.checked)
                }
            }
        });
    }

    const addNewInvite = async () => {
        let avatars = null;
        try {
            const user = await fetch(`/ajax/user`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'CSRF-Token': Cookies.get('XSRF-TOKEN')
                },
                body: JSON.stringify({qid: input.qid.value})
            })
            const user_json = await user.json();
            avatars = user_json.result[0].avatars;
        } catch (e) {
            console.log(e)
        }
        let invite_data = {
            qid: input.qid.value,
            groups: input.groups.value.filter((g) => g.checked).map((g) => {
                return {name: g.name, id: g.organization_group_id}
            }),
            description: input.description.value,
            name: input.name,
            avatars: avatars
        };
        if (permission !== "") {
            invite_data.permission = permission;
        }
        setInviteList((prevInvites) => {
            const l =  [...prevInvites.filter(i => i.qid !== invite_data.qid), invite_data];
            disPatcher({type: 'inviteAdmin_setInviteList', payload: l});
            return l;
        });
        setShowInvite(false);
        setInput({...init_input, groups: {value: wizard_data.groups, error: null, required: true}});
    }

    const canAddMore = (current_inviteList) => {
        const checkList = current_inviteList || inviteList;
        const valid = !checkList.some((i) => i.error) && !checkList.some((i) => !i.value);
        setCanAddMoreInvite(valid);
    }

    const addMore = () => {
        const key = new Date().getTime();
        setInviteList((prevInvites) => {
            const newInvite = {
                value: "",
                error: null,
                required: true,
                showAddMore: true,
                hideRemove: false,
                key
            };
            return [...prevInvites, newInvite];
        });
        if (!canAddMore()) return;
    }

    const effectCallback = (currentInput, data, setValueCallback) => {
        setInviteList((prevInviteList) => {
             prevInviteList.map((item, index) => {
                 if (item.key === data.key) {
                     item.value = currentInput.qid.value;
                     item.error =  validation({target: {value: currentInput?.qid?.value}});
                 }
                 return item;
             });
             canAddMore(prevInviteList);
             disPatcher({type: 'inviteAdmin_setInviteList', payload: prevInviteList});
             return prevInviteList;
        });
    }

    const onRoleChange = (role) => {
        disPatcher({type: 'inviteAdmin_setRole', payload: ROLE_LIST[role]});
    }

    return (
        <>
            <div>{t('@You can invite administrators to a group. Invitees will be sent emails with a confirmation link. After clicking the link, they will be able to manage devices and services through the myQNAPcloud website.@')}</div>
            <div className="form-wrapper mt-24">
                <form>
                    <SelectInputComponent label={t('@Role@')} field_name={'role'} input={input} setInput={setInput} empty_text={t('@Choose a role@')} listData={Object.keys(ROLE_LIST)} auto_width={false} useLocale={true} show_note={true} note_message={t(ROLE_NOTES?.[input?.role?.value]) || ""} onChange={onRoleChange}/>

                    {wizard_data?.groups?.length > 0 && <div className="form-row">
                        <div className="form-label"><label>{t('@Group@')}</label></div>
                        <div className="form-field">
                            <div className="comp-select" ref={node}>
                                <div className="select-toggle">
                                    <span className="select-label">
                                        {wizard_data?.groups?.filter((g) => g.checked).map((g) => g.name).join(', ')}
                                        {wizard_data?.groups?.filter((g) => g.checked).length <= 0 ? t('@Select the group@') : ''}
                                    </span>
                                </div>
                                <div className={`comp-dropdown ${open === 'show' ? '' : 'hide'}`}>
                                    <ul className="comp-dropdown-menu">
                                        <li className="section add-scroll">
                                            {wizard_data?.groups?.map((g, index) => {
                                                return (
                                                    <div className="section-items" key={index}>
                                                        <div className="comp-checkbox">
                                                            <input type="checkbox" id={`cb-${index}`}
                                                                   onChange={() => toggleGroup(g)}
                                                                   checked={g.checked || false}/>
                                                            <label htmlFor={`cb-${index}`} className="comp-label">
                                                                {g.name}
                                                            </label>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>}

                    <div className="form-row">
                        <div className="form-label required"><label>{t('@QNAP ID (Email Address)@')}</label></div>
                        <div className="form-field">
                            {
                                inviteList.map((item, index) => <InviteContactComponent
                                    setInviteList={setInviteList}
                                    validator={validation}
                                    showAddMore={true}
                                    checkAddMore={canAddMore}
                                    data={{...item, index, showAddMore: index === inviteList.length - 1, hideRemove: inviteList.length === 1}}
                                    effectCallback={effectCallback}
                                    key={item.key}/>)
                            }
                            <div className="contact-action-group">
                                <button type="button" className="q-btn q-btn-primary q-btn-tiny q-btn-round-corner" disabled={!canAddMoreInvite} onClick={addMore}>{t('@Add Another@')}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default OrganizationInviteAdminComponent;